import React, { useContext, useEffect, useState } from "react";
import * as FeedBackServices from "../../services/feedbackService";
import { SocketContext, ThemeContext } from "../../layout/BaseLayout";
import moment from "moment";

export default function Feedback(props) {

  const serverTimeZone = !!localStorage.getItem('timezone') ? JSON.parse(localStorage.getItem('timezone'))?.value : "";
  let toast = useContext(ThemeContext);
  let socket = useContext(SocketContext);
  const token = sessionStorage.getItem("token");
  let curLogin = localStorage.getItem("curLogin");
  curLogin = JSON.parse(curLogin);

  const [feedbackList, setFeedbackList] = useState([]);
  const [chatDetailsList, setChatDetailsList] = useState([]);
  const [view, setView] = useState("main");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [commonSocketData, setCommonSocketData] = useState(null);
  const [replyText, setReplyText] = useState('');
  const [messageError, setMessageError] = useState(false);

  const getFeedbackData = () => {
    FeedBackServices.getFeedBackList().then((res) => {
      if (res.isSuccess) {
        setFeedbackList(res?.data);
      }
    })
  }

  const onSubmitFeedback = () => {
    setView("main");
  }

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    const maxSizeInBytes = 10 * 1024 * 1024;
    if (selectedFile && selectedFile.size <= maxSizeInBytes) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        setFileType(selectedFile.type);
      };
      reader.readAsDataURL(selectedFile);
    } else {
      toast.error('Please select a file smaller than 10MB.');
      setPreview(null);
      setFileType(null);
    }
  };

  const getDetailOfChat = (id) => {
    FeedBackServices.detailOfChat(id).then((res) => {
      if (res.isSuccess) {
        setChatDetailsList(res.data);
      } else {
        toast.error(res?.exception?.message);
      }
    })
  }

  const submitReply = () => {
    let isValid = true;
    if (!replyText) {
      setMessageError(true);
      isValid = false;
    }
    let frmData = new FormData();
    frmData.append("feedbackId", chatDetailsList?.feedbackId);
    frmData.append("feedbackMessage", replyText);
    frmData.append("files", file ? file : []);
    FeedBackServices.sendReply(frmData).then((res) => {
      if (res.isSuccess) {
        toast.success(res?.successMessage);
      } else {
        toast.error(res?.exception?.message);
      }
    })
  }

  useEffect(() => {
    if (window.location.pathname !== '/' && !!token) {
      socket.on("ON_COMMON_ROOM", onCommonRoomSocketHandler);
      return () => {
        socket.off("ON_COMMON_ROOM", onCommonRoomSocketHandler);
      }
    }
  }, []);

  const onCommonRoomSocketHandler = (data) => {
    if (!!data && !!data.Message) {
      setCommonSocketData(data);
    }
  };

  useEffect(() => {
    if (!!commonSocketData) {
      if (window.location.pathname === '/feedback') {
        let tempFeedbackList = [...feedbackList];
        if (commonSocketData.Type === 'ADD_FEEDBACK') {
          tempFeedbackList.push(commonSocketData.Data[0]);
          setFeedbackList(tempFeedbackList);
        } else if (commonSocketData.Type === 'DELETE_FEEDBACK') {
          tempFeedbackList = tempFeedbackList.filter((val) => val.feedbackId === commonSocketData.Data.feedbackId);
          setFeedbackList(tempFeedbackList);
        } else if (commonSocketData.Type === 'REPLY_FEEDBACK') {
          const index = tempFeedbackList.findIndex((item) => item.feedbackId === commonSocketData.Data.feedbackId);
          if (index !== -1) {
            tempFeedbackList[index] = {
              ...tempFeedbackList[index],
              isReadPending: true,
            };
            setFeedbackList(tempFeedbackList);
          }

          setChatDetailsList(prev => {
            return {
              ...prev, chatList: [...(prev?.chatList || []), commonSocketData.Data]
            };
          });
        }
      }
      setCommonSocketData(null);
    }
  }, [commonSocketData])

  useEffect(() => {
    getFeedbackData();
  }, [])

  return (
    <div className="bgmain h100 position-relative">
      <div className="header border-bottom">
        <div className="header-box">
          <div className="font-14 himg text-blue"
            onClick={() => {
              if (["modal", "chatdetail"].includes(view)) {
                setView("main");
              } else if (view === "main") {
                props.toSettings()
              }
            }}
          >
            <img
              src="/images/back-arrow-blue.svg"
              className="mr-1 settingheight"
              alt=""
            />
          </div>
          <div className="header-name ">Feedback</div>
          <div className="himg font-14">&nbsp;</div>
        </div>
      </div>
      <div className="middle bgmain mt-0">
        {view === "main" &&
          <div class="settingbox border-0 min-h-whitebg">
            <table class="table w-100  whitespace mb-0 tradetb">
              <tbody>
                {(!!feedbackList && feedbackList?.length > 0) && feedbackList?.map((item, index) => {
                  const convertedFeedbackDate = !!item.feedbackDate ? new Date(item.feedbackDate).toLocaleString("sv-SE", { timeZone: serverTimeZone }) : null;
                  const splittedDate = convertedFeedbackDate.split(" ");
                  return (
                    <>
                      <tr onClick={() => { setView("chatdetail"); getDetailOfChat(item?.feedbackId) }}>
                        <td class="w-75 font-12 font-bold">
                          <div class="">
                            <span class="font-12 mr-2">{splittedDate[0]}</span>
                            <span class="font-12 ">{splittedDate[1]}</span>
                          </div>
                          <div>
                            <span class="font-12 font-bold mr-2">{item.feedbackSubject}</span>
                          </div>
                        </td>
                        <td class="w-25 himg ">
                          <div class="font-12 font-bold text-right">
                            <img
                              src="/images/right-arrow.svg"
                              alt=""
                              className="settingheight"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="" colspan="2">
                          <hr />
                        </td>
                      </tr>
                    </>
                  )
                })}
              </tbody>
            </table>
          </div>
        }

        {view === "chatdetail" &&
          <div class="settingbox border-0 min-h-whitebg">
            <div className="chatborderbox">
              <div className="chatborderbox-title">{chatDetailsList?.feedbackSubject}</div>
              <div className="chatborderbox-title-inner">{chatDetailsList?.feedbackMessage}</div>
            </div>
            {!!chatDetailsList?.chatList && chatDetailsList?.chatList?.length > 0 && chatDetailsList?.chatList?.map((item, index) => {
              return (

                <div className="chatborderbox-sr">
                  {item?.userRole === "Client" ?
                    <>
                    
                      <div className="mainchatsener-receiverbox-right">
                        <div className="sender">{item?.feedbackMessage}</div>
                        {item?.filePath?.length > 0 && item.filePath.map((url, i) => (
                          <div className='feedback-imgbox'>
                            {url.endsWith('.mp4') ? (
                              <a target='_blank' href={url} rel="noopener noreferrer" className='feedback-imgbox'>
                                <video className='feedback-img-50' controls>
                                  <source src={url} type='video/mp4' />
                                </video>
                              </a>
                            ) : url.endsWith('.pdf') ? (
                              <object data={url} type="application/pdf" width="50%" height="250px">
                                <embed className='feedback-img-50' src={url} type="application/pdf" />
                              </object>
                            ) : (
                              <a target='_blank' href={url} rel="noopener noreferrer" className='feedback-imgbox'>
                                <img className='feedback-img-50' src={url} alt={`Media ${i}`} /></a>
                            )}
                          </div>
                        ))}
                        <div className="date-time-chat">{!!item?.createdOn ? moment(new Date(item?.createdOn + '+00:00').toLocaleString('sv-SE', { timeZone: serverTimeZone })).format('DD/MM/YY HH:mm:ss') : ''}
                          <span><img className="double-tick-icon ml-1" src={`/images/double-${item?.isRead ? "blue" : "gray"}.svg`} /></span>
                        </div>
                      </div>
                    </>
                    :
                    <div className="mainchatsener-receiverbox">
                      <div className="receiver" dangerouslySetInnerHTML={{ __html: item?.feedbackMessage }}>
                      </div>
                      {item?.filePath?.length > 0 && item.filePath.map((url, i) => (
                        <div className='feedback-imgbox'>
                          {url.endsWith('.mp4') ? (
                            <a target='_blank' href={url} rel="noopener noreferrer" className='feedback-imgbox'>
                              <video className='feedback-img-50' controls>
                                <source src={url} type='video/mp4' />
                              </video>
                            </a>
                          ) : url.endsWith('.pdf') ? (
                            <object data={url} type="application/pdf" width="50%" height="250px">
                              <embed className='feedback-img-50' src={url} type="application/pdf" />
                            </object>
                          ) : (
                            <a target='_blank' href={url} rel="noopener noreferrer" className='feedback-imgbox'>
                              <img className='feedback-img-50' src={url} alt={`Media ${i}`} /></a>
                          )}
                        </div>
                      ))}
                      <div className="date-time-chat">{!!item?.createdOn ? moment(new Date(item?.createdOn + '+00:00').toLocaleString('sv-SE', { timeZone: serverTimeZone })).format('DD/MM/YY HH:mm:ss') : ''}</div>
                    </div>
                  }
                </div>
              )
            })}
            <div className="feedback-footer">
              <div className="feedback-footer-dflex">
                <div className="feedbackfooter75">
                  <div class="form-group mb-0 mr-2">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Type Message"
                      value={replyText}
                      onChange={(e) => setReplyText(e.target.value)}
                    />
                  </div>
                </div>
                <div className="feedbackfooter25">
                  <div>
                    <span className="mr-2"><img src="/images/add-picture.svg"></img></span>
                    <span onClick={() => submitReply()}><img src="/images/sendfile.svg"></img></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        {/* FEEDBACK FORM START */}
        {view === "modal" &&
          <div className="settingbox border-0 min-h-whitebg">
            <div class="form-group">
              <input
                type="email"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Subject"
              />
            </div>
            <div class="form-group mt-3">
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                placeholder="Message"
              ></textarea>
            </div>
            <div className="mb-3">
              <input
                type='file'
                onChange={handleFileChange}
                accept="image/*, video/mp4, application/pdf"
              />
              {preview && (
                <div>
                  <div>
                    {fileType.includes('image') ? (
                      <img className='feedback-img mb-2 mt-2' src={preview} alt={`File preview`} />
                    ) : fileType.includes('video') ? (
                      <video className='feedback-video' controls>
                        <source src={preview} type='video/mp4' />
                      </video>
                    ) : fileType.includes('pdf') ? (
                      <embed className='feedback-pdf' src={preview} type="application/pdf" />
                    ) : (
                      <div>Unsupported file type</div>
                    )}
                  </div>
                </div>
              )
              }
            </div>
            <div>
              <button type="button" class="buybtn w-100" onClick={() => onSubmitFeedback()}>
                Submit
              </button>
            </div>
          </div>
        }
      </div>
      {view !== "chatdetail" &&
        <div className="addfeedbackbtn" onClick={() => setView("modal")}>
          <img src={"/images/plus-white.svg"} alt="" />
        </div>
      }
    </div>
  );
}
